import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Button,
  ModalBody,
  Form,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent
} from "reactstrap"
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import useForm from "../../../lib/useForm"
import ReactSelect from "../../../components/Form/Select/Select"
import Loading from 'lib/loading'
import NumberFormat from 'react-number-format';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { cpf } from 'cpf-cnpj-validator'
import "./styles.css"

const formSwal = withReactContent(Swal)

const FormVendedor = ({ fechaModal, vendedor_id, setVendedor_id}) => {
  const inicialForm = {
    vendedor_id: '',
    vendedor: '',
    adm: 'N',
    ativo: 'N',
    loja: '',
    cpf: '',
    senha: '',
    fator_comissao: '100',
    fp: 'N',
    senha_fp: '',
    acesso_prod: 'N',
    acesso_lojas: 'N',
    acesso_adm: 'N',
    acesso_cli: 'N',
    acesso_venda: 'N',
    acesso_contasreceb: 'N',
    acesso_caixa: 'N',
    acesso_contaspag: 'N',
    acesso_pedidos: 'N',
    acesso_reajuste: 'N',
    acesso_parametros: 'N',
    acesso_relpag: 'N',
    acesso_relreceb: 'N',
    acesso_relcaixa: 'N',
    acesso_relcomis: 'N',
    acesso_estatisticas: 'N',
    acesso_desbloq: 'N',
    acesso_exclusao_vendas: 'N',
    acesso_cdi: 'N',
    acesso_desconto: 'N',
    acesso_boletas: 'N',
    acesso_controlados: 'N',
    acesso_exclusao_item: 'N',
    acesso_exclusao_notas: 'N',
    acesso_consulta_vendas: 'N',
    acesso_remoto: 'N',
    acesso_fidelidade: 'N',
    confSenhaFP: '',
    lojaSelect:'',
    ativoSelect:[{"id":"N", "title":"Não"}],
    acesso_admSelect:[{"id":"N", "title":"Não"}]
  }

  //valores da lista de ativos
  const listaAtivo = [
    {"id":"S", "title":"Sim"},
    {"id":"N", "title":"Não"}
  ]

  const [form, onChange, setForm, onChangeSelect] = useForm(inicialForm)
  const [listaLoja, setListaLoja]                 = useState([])
  const [loading, setLoading]                     = useState(true)
  const [activeTab, setActiveTab]                 = useState('1')
  const [fPopular, setFPopular]                   = useState(false)

  const listaLojas = () => {
    let lista = []
    const url = rotas.lojas
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret.success && ret.success === 'S' && ret.lista !== ''){
          lista[0] = {"id":"0", "title":"TODAS AS LOJAS"}

          for (let i = 0; i < ret.lista.length; i++) {
            lista[i+1] = {"id":ret.lista[i].filial_id, "title":ret.lista[i].fantasia}
          }

          setListaLoja(lista)
        }
      })
      return (true)

    }catch(err){
      return (false)
    }
  }

  const editVendedor = (vendedor_id) => {
    const url     = rotas.vendedor+vendedor_id,
          retorno = rest.get(url)

    retorno.then(ret => {
      if (ret.success && ret.success === 'S' && ret.lista !== '') {

        if (ret.lista[0].filial_id === 0) {
          ret.lista[0].loja = "TODAS AS LOJAS"
        }

        ret.lista[0].lojaSelect       = {"id":ret.lista[0].filial_id, "title":ret.lista[0].loja}
        ret.lista[0].acesso_admSelect = selectSN(ret.lista[0].acesso_adm)
        ret.lista[0].ativoSelect      = selectSN(ret.lista[0].ativo)
        ret.lista[0]['confSenhaFP']   = ret.lista[0].senha_fp
        ret.lista[0]['senha']         = ''

        setFPopular(true)

        if (ret.lista[0].senha_fp !== '') {
          ret.lista[0]['fp'] = 'S'

          setFPopular(false)
        }

        setForm(ret.lista[0])
        setLoading(false)
      }
    })
  }

  const selectSN = (select) => {
    if (select === 'S') {
      return {"id":"S", "title":"Sim"}
    } else {
      return {"id":"N", "title":"Não"}
    }
  }

  useEffect(() => {
    if (listaLojas()) {
      if(vendedor_id !== ''){
        editVendedor(vendedor_id)
      }else{
        setForm(inicialForm)
        setLoading(false)
        setFPopular(true)
      }
    }
  },[] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const clickADM = () => {
    form.acesso_adm = form.acesso_admSelect.id
  }

  const clickAtivo = () => {
    if(vendedor_id !== ''){
      form.ativo = form.ativoSelect.id
    }
  }

  const clikFP = (e) => {
    var check = (e.target.checked)
    check ? setFPopular(false) : setFPopular(true)
  }

  const validate = () => {

    //campo senha farmacia popular
    if (form.fp === 'S'){
      if (form.senha_fp !== '') {
        if (form.senha_fp !== form.confSenhaFP) {
          formSwal.fire('Alerta!', 'Campo confirma senha farmacia popular diferente.', 'info')
          return true
        }
      }else{
          formSwal.fire('Alerta!', 'Campo senha farmacia popular inválido.', 'info')
          return true
      }
    }

    //campo senha vendedor
    if(vendedor_id === ''){
      if (form.senha.trim() === ''){
      formSwal.fire('Alerta!', 'Campo SENHA é obrigatório.', 'info')
      return true
      }
    }

    return false
  }

  //SUBMIT
  const handleSubmit = (evt) => {
    evt.preventDefault()

    if (validate()) {
      return false
    }

    form.acesso_adm = form.acesso_admSelect.id ? form.acesso_admSelect.id : 'N';
    form.ativo      = form.ativoSelect.id ? form.ativoSelect.id : 'N';
    form.loja       = form.lojaSelect.id ? form.lojaSelect.id: 'N';

    formSwal.queue([{
      title: 'Deseja salvar ?',
      confirmButtonText: 'Salvar',
      showCancelButton: true,
      text:'Essas informações serão salvas no banco',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',
      preConfirm: () => {
        const url = rotas.vendedor+'gravar.php'
        if(vendedor_id !== ''){
          return rest.post(url, form)
          .then(ret => {

            if (ret.success === 'S') {
              editVendedor(vendedor_id)
              formSwal.fire('Salvo!',
                            ret.msg,
                            'success')
            }else{
              formSwal.fire('Erro!',
                            ret.msg,
                            'error')
            }
          })

        }else{
          return rest.put(url, form)
          .then(ret => {

            if (ret.success === 'S') {
              setVendedor_id(ret.vendedor_id)
              editVendedor(ret.vendedor_id)
              formSwal.fire('Salvo!',
                            ret.msg,
                            'success')
            }else{
              formSwal.fire('Erro!',
                            ret.msg,
                            'error')
            }
          })
        }
      }
    }])
  }

  if (loading) {
    return (
      <ModalBody className ="loadingBody">
        <Loading tipo='componente'/>
      </ModalBody>
    )
  }else {
    return (
      <FormGroup className="formCadastro">
        <ModalBody className="pb-0">
          <Nav pills className="nav-pills-default justify-content-center mb-3">

            <NavItem>
              <NavLink
                className = {activeTab === '1' ? 'active' : ''}
                onClick   = {() => setActiveTab('1')}
              >
                Dados Pessoais
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={activeTab === '2' ? 'active' : ''}
                onClick={() => setActiveTab('2')}
              >
                Acessos
              </NavLink>
            </NavItem>
          </Nav>

          <hr />

          {/* DADOS PESSOAIS */}
          <Form onSubmit={handleSubmit} autoComplete="off">
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
                <Row>
                  <Col md='2'>
                    <FormGroup>
                      <Label for="vendedor_id">Código</Label>
                      <Input
                        disabled
                        style     = {{background: '#F9F9F9'}}
                        name      = "vendedor_id"
                        id        = "vendedor_id"
                        value     = {form.vendedor_id}
                        onChange  = {onChange('vendedor_id')}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='2'>
                    <FormGroup>
                      <ReactSelect
                        name          = "administrador"
                        label         = "administrador"
                        placeholder   = "Selecione"
                        options       = {listaAtivo}
                        defaultValue  = {form.acesso_admSelect}
                        onChange      = {onChangeSelect('acesso_admSelect')}
                        onClick       = {clickADM()}
                      >
                      </ReactSelect>
                    </FormGroup>
                  </Col>

                  <Col md='2'>
                    <FormGroup>
                      <ReactSelect
                        name          = "ativo"
                        label         = "ativo"
                        placeholder   = "Selecione"
                        options       = {listaAtivo}
                        defaultValue  = {form.ativoSelect}
                        onChange      = {onChangeSelect('ativoSelect')}
                        onClick       = {clickAtivo()}
                      >
                      </ReactSelect>
                    </FormGroup>
                  </Col>

                  <Col md='4'>
                    <FormGroup>
                      <ReactSelect
                        required
                        name          = "lojas"
                        label         = "loja origem"
                        placeholder   = "Selecione"
                        options       = {listaLoja}
                        defaultValue  = {form.lojaSelect}
                        onChange      = {onChangeSelect('lojaSelect')}
                        onClick       = {form.loja = form.lojaSelect.id}
                      >
                      </ReactSelect>
                    </FormGroup>
                  </Col>

                  <Col md='2'>
                    <FormGroup>
                    <Label for="comissao">Fator Comissão</Label>
                      <Input
                        required
                        type      = "number"
                        name      = "comissao"
                        value     = {parseInt(form.fator_comissao)}
                        onChange  = {onChange('fator_comissao')}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md='6'>
                    <FormGroup>
                      <Label for="vendedor">vendedor</Label>
                      <Input
                        required
                        id        = "vendedor"
                        name      = "vendedor"
                        value     = {form.vendedor}
                        onChange  = {onChange('vendedor')}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='3'>
                    <FormGroup>
                      <Label for="cpf">cpf</Label>
                      <NumberFormat
                        required
                        id        = "cpf"
                        name      = "cpf"
                        type      = "text"
                        mask      = "_"
                        format    = "###.###.###-##"
                        value     = {form.cpf}
                        onChange  = {onChange('cpf')}
                        className = {cpf.isValid(form.cpf) ? "form-control" : "form-control number-format-invalid"}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='3'>
                    <FormGroup>
                      <Label for="cpf">Senha</Label>
                      <Input
                        id          = "senha"
                        name        = "senha"
                        type        = "password"
                        placeholder = "****"
                        value       = {form.senha}
                        onChange    = {onChange('senha')}
                        autoComplete="new-password"
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row className="card-2">
                  <Col md="3">
                    <span className="tag-card">
                      <FormGroup check inline className="mb-0">
                        <Label check>
                          <Input
                            id        = "fp"
                            name      = "fp"
                            type      = "checkbox"
                            checked   = {form.fp === 'S' ? true : false}
                            onChange  = {onChange('fp')}
                            onClick   = {clikFP}
                          />
                          <span className="form-check-sign" />farmácia popular
                        </Label>
                      </FormGroup>{" "}
                    </span>
                  </Col>

                  <Col md="3">
                    <FormGroup>
                      <Label for="cpf">Senha farmácia popular</Label>
                      <Input
                        id        = "senha_fp"
                        name      = "senha_fp"
                        type      = "password"
                        value     = {form.senha_fp}
                        onChange  = {onChange('senha_fp')}
                        disabled  = {fPopular}
                      />
                    </FormGroup>
                  </Col>

                  <Col md="3">
                    <FormGroup>
                      <Label for="cpf">Conf. senha farmácia popular</Label>
                      <Input
                        id    = "conf_senha_fp"
                        name  = "conf_senha_fp"
                        type  = "password"
                        value = {form.confSenhaFP}
                        onChange  = {onChange('confSenhaFP')}
                        disabled  = {fPopular}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              {/* </Form> */}
            </TabPane>
          </TabContent>

          {/* ACESSOS */}
          <TabContent activeTab={activeTab}>
            <TabPane tabId="2" >
              <Row>

                {/* bloquear tela ADM */}
                <div className={form.acesso_adm === "S" ? "classAcessoADM" : "d-none"}>
                <span>ADMINISTRADOR</span>
                </div>

                {/* ADMINISTRATIVO */}
                <div className="card-2 mr-3">
                  <Col>
                    <span className="tag-card">Admistrativo</span>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "acesso_lojas"
                          type      = "checkbox"
                          value     = {form.acesso_lojas}
                          onChange  = {onChange('acesso_lojas')}
                          checked   = {form.acesso_lojas === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Acessar lojas
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "estoque"
                          type      = "checkbox"
                          value     = {form.acesso_reajuste}
                          onChange  = {onChange('acesso_reajuste')}
                          checked   = {form.acesso_reajuste === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Alterar estoque
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "cancelar_item_venda"
                          type      = "checkbox"
                          value     = {form.acesso_exclusao_item}
                          onChange  = {onChange('acesso_exclusao_item')}
                          checked   = {form.acesso_exclusao_item === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Cancelar Item na Venda
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "configuracoes"
                          type      = "checkbox"
                          value     = {form.acesso_parametros}
                          onChange  = {onChange('acesso_parametros')}
                          checked   = {form.acesso_parametros === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Configurações
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "consultar_vendas"
                          type      = "checkbox"
                          value     = {form.acesso_venda}
                          onChange  = {onChange('acesso_consulta_vendas')}
                          checked   = {form.acesso_consulta_vendas === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Consultar Vendas
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "desbloqueio_clientes"
                          type      = "checkbox"
                          value     = {form.acesso_desbloq}
                          onChange  = {onChange('acesso_desbloq')}
                          checked   = {form.acesso_desbloq === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Desbloqueio de Clientes
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "exclusao_vendas"
                          type      = "checkbox"
                          value     = {form.acesso_exclusao_vendas}
                          onChange  = {onChange('acesso_exclusao_vendas')}
                          checked   = {form.acesso_exclusao_vendas === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Exclusão de Vendas
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "exclusao_notas"
                          type      = "checkbox"
                          value     = {form.acesso_exclusao_notas}
                          onChange  = {onChange('acesso_exclusao_notas')}
                          checked   = {form.acesso_exclusao_notas === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Exclusão Notas
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "inadimplentes"
                          type      = "checkbox"
                          value     = {form.acesso_cdi}
                          onChange  = {onChange('acesso_cdi')}
                          checked   = {form.acesso_cdi === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Inadimplentes
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "permitir_desc_extras"
                          type      = "checkbox"
                          value     = {form.acesso_desconto}
                          onChange  = {onChange('acesso_desconto')}
                          checked   = {form.acesso_desconto === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Permitir Desc. Extras
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "efetua_vendas"
                          type      = "checkbox"
                          value     = {form.acesso_venda}
                          onChange  = {onChange('acesso_venda')}
                          checked   = {form.acesso_venda === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Efetua Vendas
                      </Label>
                    </FormGroup>
                  </Col>
                </div>

                {/* CADASTRO */}
                <div className="card-2 mr-3">
                  <Col>
                    <span className="tag-card">Cadastros</span>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "cartao_fidelidade"
                          type      = "checkbox"
                          value     = {form.acesso_fidelidade}
                          onChange  = {onChange('acesso_fidelidade')}
                          checked   = {form.acesso_fidelidade === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Cartão Fidelidade
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "clientes"
                          type      = "checkbox"
                          value     = {form.acesso_cli}
                          onChange  = {onChange('acesso_cli')}
                          checked   = {form.acesso_cli === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Clientes
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "controlados"
                          type      = "checkbox"
                          value     = {form.acesso_controlados}
                          onChange  = {onChange('acesso_controlados')}
                          checked   = {form.acesso_controlados === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Controlados
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "lanca_notas"
                          type      = "checkbox"
                          value     = {form.acesso_pedidos}
                          onChange  = {onChange('acesso_pedidos')}
                          checked   = {form.acesso_pedidos === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Lanças Notas (Pedidos)
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "produtos"
                          type      = "checkbox"
                          value     = {form.acesso_prod}
                          onChange  = {onChange('acesso_prod')}
                          checked   = {form.acesso_prod === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Produtos
                      </Label>
                    </FormGroup>
                  </Col>
                </div>

                {/* FINANCEIRO */}
                <div className="card-2 mr-3">
                  <Col>
                    <span className="tag-card">Financeiro</span>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "baixar_boletas"
                          type      = "checkbox"
                          value     = {form.acesso_boletas}
                          onChange  = {onChange('acesso_boletas')}
                          checked   = {form.acesso_boletas === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Baixar Boletas
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "caixa"
                          type      = "checkbox"
                          value     = {form.acesso_caixa}
                          onChange  = {onChange('acesso_caixa')}
                          checked   = {form.acesso_caixa === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Caixa
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "contas_pagar"
                          type      = "checkbox"
                          value     = {form.acesso_contaspag}
                          onChange  = {onChange('acesso_contaspag')}
                          checked   = {form.acesso_contaspag === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Contas à Pagar
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "contas_receber"
                          type      = "checkbox"
                          value     = {form.acesso_contasreceb}
                          onChange  = {onChange('acesso_contasreceb')}
                          checked   = {form.acesso_contasreceb === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Contas á Receber
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "graficos_estatisticas"
                          type      = "checkbox"
                          value     = {form.acesso_estatisticas}
                          onChange  = {onChange('acesso_estatisticas')}
                          checked   = {form.acesso_estatisticas === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Gráficos e Estatísticas
                      </Label>
                    </FormGroup>
                  </Col>
                </div>

                {/* RELATÓRIOS */}
                <div className="card-2 mr-3">
                  <Col>
                    <span className="tag-card">Relatórios</span>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "contas_pagar"
                          type      = "checkbox"
                          value     = {form.acesso_relpag}
                          onChange  = {onChange('acesso_relpag')}
                          checked   = {form.acesso_relpag === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Contas à Pagar
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "contas_receber"
                          type      = "checkbox"
                          value     = {form.acesso_relreceb}
                          onChange  = {onChange('acesso_relreceb')}
                          checked   = {form.acesso_relreceb === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Contas à Receber
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "comissoes"
                          type      = "checkbox"
                          value     = {form.acesso_relcomis}
                          onChange  = {onChange('acesso_relcomis')}
                          checked   = {form.acesso_relcomis === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Comissões
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input
                          name      = "resumo_caixa"
                          type      = "checkbox"
                          value     = {form.acesso_relcaixa}
                          onChange  = {onChange('acesso_relcaixa')}
                          checked   = {form.acesso_relcaixa === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Resumo de Caixa
                      </Label>
                    </FormGroup>
                  </Col>
                </div>
              </Row>
            </TabPane>
          </TabContent>

          <Col className="text-center p-3">
            <Button type="submit" className="mb-0 mt-0" color="success" size="md">Salvar</Button>
            <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>Fechar</Button>
          </Col>
          </Form>
        </ModalBody>
      </FormGroup>
    )
  }
}

export default FormVendedor
